export const packages = {
  notAssignedPackages:
    'Brak przypisanych pakietów. Wybierz jeden z listy lub utwórz nowy, aby przypisać go do opcji.',
  name: 'Nazwa',
  code: 'Kod',
  startAt: 'Data rozpoczęcia',
  expiresAt: 'Data ważności',
  addingPackage: 'Dodawanie nowego pakietu',
  editPackage: 'Edytuj pakiet',
  assignPackageToOption: 'Pakiety nieprzypisane do opcji',
  defaultSelected: 'Domyślnie zaznaczony',
  forceSelect: 'Wymuś zaznaczenie',
  titleFor: 'Pakiety dla szablonów konfiguracji',
  addNew: 'Dodaj nowy pakiet',
  options: 'Opcje przypisane do pakietu',
  linkOption: 'Przypisz opcję',
  unLinkOption: 'Usuń przypisanie',
  unLinkOptionConfirmation:
    'Usuwasz przypisanie opcji "{label}" do pakietu. Czy chcesz kontynuować?',
  selectOption: 'Wybierz opcję...',
  noOptions: 'Brak przypisanych opcji',
  linkedOption: 'Przypisano nową opcję do pakietu',
  assignmentValue: 'Wartość opcji',
  assignmentValueRequired: 'Uzupełnij poprawną wartość opcji.',
  assignmentValuePlaceholderNumber: 'Wpisz wartość liczbową',
  unlinkedOption: 'Usunięto przypisanie opcji do pakietu',
  deletePackage: 'Usuń pakiet',
  deletedQuestion: 'Czy na pewno chcesz usunąć pakiet "{packageName}"?',
  packageDeleteSuccess: 'Pakiet usunięto poprawnie',
  managePackagesDescription:
    'Zarządzaj pakietami i edytuj ich ustawienia przypisania wykorzystywane w opcjach.',
  flowNotFound: 'Nie znaleziono szablonu konfiguracji.',
  applyPackage: 'Pakiet został zaplikowany',
}
